<script>
  const layers = [0, 1, 2, 3, 4, 5, 6, 7, 8];

  let y
  let href = "#";
</script>

<svelte:window bind:scrollY={y}/>

<div class="parallax-container " >
  {#each [0, 1, 2, 3, 4, 5, 6, 7, 8] as layer}
    <img
      class=""
      style="transform: translate(0,{-y * layer / (layers.length - 1)}px)"
      src="./assets/imgs/parallax{layer}.png"
      alt="parallax layer {layer}"
    >
  {/each}
</div>

<div class="text animate__animated animate__fadeIn">
  <h1 style="opacity: {1 - Math.max(0, y / 40)}">
    2021年1月 九阳投票大赛
  </h1>

  <div class="foreground">
    <!-- You have scrolled {y} pixels -->
    <slot></slot>
  </div>
</div>

<a href="./#" class="arrow">↑</a>

<style>
  .arrow{
    position: fixed;
    padding: 10px;
    bottom: 1rem;
    right: 1rem;
    background-color: white;
  }

  .parallax-container {
    position: fixed;
    width: 2400px;
    height: 712px;
    left: 50%;
    transform: translate(-50%,0);
  }

  .parallax-container img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    will-change: transform;
  }

  .parallax-container img:last-child::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgb(45,10,13);
  }

  .text {
    position: relative;
    width: 100%;
    height: 490rem;
    color: rgb(220,113,43);
    text-align: center;
    padding: 4em 0.5em 0.5em 0.5em;
    box-sizing: border-box;
    /* pointer-events: none; */
  }

  h1 {
    display: block;
    font-size: 1em;
    text-transform: uppercase;
    will-change: transform, opacity;
  }

  .foreground {
    position: absolute;
    /* top: 240px; */
    left: 0;
    width: 100%;
    color: white;
    padding: 35rem 0 0 0;
  }

  :global(body) {
    margin: 0;
    padding: 0;
    background-color: rgb(253, 174, 51);
  }
</style>
